import { render, staticRenderFns } from "./CopyGoalForAnotherStudentButton.vue?vue&type=template&id=3e00c151"
import script from "./CopyGoalForAnotherStudentButton.vue?vue&type=script&lang=js"
export * from "./CopyGoalForAnotherStudentButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports